

(function(){
    angular.module('tmx-app').factory('AccountApplicationService', ['tmxResource','$q','$mdMedia','lookupService', function(tmxResource,$q,$mdMedia,lookupService){
        var applications = tmxResource("AccountApplication");

        applications.fetchEcib = function(cnic) {
            return  tmxResource("Integration").getByAction("GeteCIBData/"+cnic, false, 'get');
        }
      

        applications.getChecklistHistory = function (applicationId, productChecklistId) {
            return applications.getByAction("GetChecklistHistory/" + applicationId + "/" + productChecklistId, true);
        };

        applications.getTimeFrames = function(){
             
            return applications.getByAction("GetTimeFrameParameterForReport",false);
        };

        applications.postImage = function(obj){
             
            return applications.getByAction("UploadApplicationChecklistImage",false,'post',obj);
        };

        applications.getloanappjobstatus = function(){
             
            return applications.getByAction("PostLoanApplicationStatus",false);
        };

        applications.createAccountApplication = function(data){
             
            return applications.getByAction("",false,'post',data);
        };

        applications.getEcibDetail = function(){
            return tmxResource("enquiry/GeteCIBData").getById("3520268380749",true);

        }

        applications.getApplicationById = function(id){
            tmxResource("AccountApplication").getById(id).then(function(response){                 
                return response;
            });
        }
        applications.CancelById = function(accountApplicationId) {
            return  tmxResource("AccountApplication").getByAction("CancelById/"+accountApplicationId, false, 'put',{});
        }
        applications.setApplicationState = function(data){
            return  tmxResource("AccountApplication").getByAction("SetApplicationState", false, 'put',data);
        }

        applications.deleteById = function(id) {
            var deferred = $q.defer();
            tmxResource("AccountApplication").getById(id).then(function(result) {
                deferred.resolve(result.$remove());
            });
            // item.$remove();
            return deferred.promise;
        };
        var loanAppSearchGridStatus =[] ;
        lookupService.getLoanApplicationStatusLkp().then(function(LoanApplicationStatus){
            LoanApplicationStatus.forEach(function(loanAppStatusLookup) {
                loanAppSearchGridStatus.push({
                    "HiddenValue":loanAppStatusLookup.HiddenValue,
                    "VisibleValue":loanAppStatusLookup.VisibleValue
                });
            });

            //  applications.loanAppSearchGridStatus = loanAppSearchGridStatus;
            //  applications.cols[applications.cols.length-1].data = loanAppSearchGridStatus;
            //  applications.gridColumns[9].data = loanAppSearchGridStatus;


        });
        applications.gridColumns = [

            {
                field:"AccountApplicationNumber",
                title: "Application Number",
                type: "text",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('AccountApplicationNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"AccountApplicationNumber\")' ></i></span>"

            },
            {
                field:"CustomerName",
                title: "Customer",
                type: "alpha",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('CustomerName')}\" >{{'Customer' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                template: "<div>{{dataItem.CustomerName | defaultValue}} </div> <span  class='subtitle-text'> {{dataItem.NationalIdentifierValue | cnic}} </span> <span class='subtitle'>{{dataItem.CustomerCode}}</span> <span class='subtitle'>{{dataItem.CustomerAccountNumber}}</span></div>"
            },
            {
                field:"NationalIdentifierValue",
                title: "Cnic",
                type: "numeric",
                search: true,
                hidden:true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('NationalIdentifierValue')}\" >{{'Cnic' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"NationalIdentifierValue\")' ></i></span>",
                template: "<span class='nowrap'>{{dataItem.NationalIdentifierValue | cnic}}</span>"

            },
            {
                field:"ProductName",
                title:"Product",
                type:"text",
                search: true,
                template: "<span title='{{dataItem.ProductName}}'>{{ dataItem.ProductName }}</span>",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"ProductName\")' ></i></span>"
            },
            // {
            //     field:"ApprovedLoanAmount",
            //     title:"Apv. Amount",
            //     type: "integer",
            //     search: true,
            //     template: " \{\{AccountOpeningApplicationCtrl.formatLoanAmount(dataItem.ApprovedLoanAmount) | tmxCurrency\}\} ",
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('RequestedLoanAmount')}\" >Amount<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"RequestedLoanAmount\")' ></i></span>"
            // },
            // {
            //     field:"TotalTenure",
            //     title:"Tenure",
            //     type:"select",
            //     search: true,
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('TotalTenure')}\" >Tenure<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"TotalTenure\")' ></i></span>",
            //     template:" \{\{AccountOpeningApplicationCtrl.formatTenure(dataItem.TotalTenure)\}\} "

            // },
            {
                field:"BranchName",
                title:"Branch",
                type:"text",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('BranchName')}\" >{{'Branch' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"BranchName\")' ></i></span>"
            },
            {
                field:"CreatorName",
                title:"Creator",
                type: "text",
                search: true,
                width: $mdMedia('gt-sm')?'10%':'50px', 
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('CreatorName')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"CreatorName\")' ></i></span>",
                template:"<div>{{dataItem.CreatorName}}</div><span class='subtitle-wrap '>{{ dataItem.Creator }}</span>",   
            },
            {
                field:"InboxName",
                title:"InboxUser",
                type: "text",
                search: true,
                width: $mdMedia('gt-sm')?'10%':'50px', 
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('InboxName')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"InboxName\")' ></i></span>",
                template:"<div>{{dataItem.InboxName}}</div><span class='subtitle-wrap '>{{ dataItem.InboxUser }}</span>",                  
            },
            {
                field:"accountopeningrequestdate",
                title:"App Date",
                type: "date",
                search: true,
                //format: "{0:dd MMM yyyy}",
                applySearchRangeForThisDate:true,
                template: "<span >{{dataItem.formattedAccountopeningrequestdate}}</span>",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('accountopeningrequestdate')}\" >{{'AppDate' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"accountopeningrequestdate\")' ></i></span>"
            }, //
            {
                field:"Status",
                title:"Status",
                type: "text",
                search: true,
                hidden:true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('ApplicationStatusLkp')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"ApplicationStatusLkp\")' ></i></span>"
            },
            {
                field:"CustomerCode",
                title:"CIF Number",
                type: "integer",
                search: true,
                hidden:true,
                template: "{{dataItem.CustomerCode}}",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('CustomerCode')}\" >{{'CIFNumber' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"CustomerCode\")' ></i></span>"
            },
            {
                field:"CustomerAccountNumber",
                title:"Account No",
                type: "integer",
                search: true,
                hidden:true,
                template: "{{dataItem.CustomerAccountNumber}}",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('CustomerAccountNumber')}\" >{{'AccountNo' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"CustomerAccountNumber\")' ></i></span>"
            },
            // template: "{{AccountOpeningApplicationCtrl.getLookupName(#=ApplicationStatusLkp#)}}",
            // {
            //     field:"LastUpdatedDate",
            //     title:"LastUpdatedDate",
            //     type: "date",
            //     //search: true,
            //     template: "<span ><md-tooltip md-direction='top'>{{AccountOpeningApplicationCtrl.formatDateTime(dataItem.LastUpdatedDate,1)}}</md-tooltip> \{\{AccountOpeningApplicationCtrl.formatDateTime(dataItem.LastUpdatedDate,0)\}\}</span>",
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('LastUpdatedDate')}\" >LastUpdatedDate<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"LastUpdatedDate\")' ></i></span>"
            // },
            // {
            //     field:"MWStatus",
            //     title:"MWStatus",
            //     type: "text",
            //     //template: "{{AccountOpeningApplicationCtrl.getLookupName(#=ApplicationStatusLkp#)}}",
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('MWStatus')}\" >MWStatus<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"MWStatus\")' ></i></span>"
            // },
            // {
            //     field:"MWPostedDate",
            //     title:"MWPostedDate",
            //     type: "date",
            //     //search: true,
            //     template: "<span ><md-tooltip md-direction='top'>{{AccountOpeningApplicationCtrl.formatDateTime(dataItem.MWPostedDate,1)}}</md-tooltip> \{\{AccountOpeningApplicationCtrl.formatDateTime(dataItem.MWPostedDate,0)\}\}</span>",
            //     //format: "{0:dd MMM yyyy}",
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('MWPostedDate')}\" >MWPostedDate<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"MWPostedDate\")' ></i></span>"
            // },
            {
                template: "<md-menu flex='none' class='menu-list-item' md-offset='-20 60' ><md-button class='menu-list-item-grid' ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button>"
                                +"<md-menu-content width='2' >"
                                    +"<md-menu-item><md-button aria-label='del' class='tmxMin' ng-disabled='!AccountOpeningApplicationCtrl.deletePermission' ng-click='AccountOpeningApplicationCtrl.clickDelete(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>delete</md-icon>Cancel</md-button></md-menu-item>"
                                    +"<md-menu-item><md-button aria-label='del' class='tmxMin' ng-disabled='!AccountOpeningApplicationCtrl.assignPermission' ng-click='AccountOpeningApplicationCtrl.clickAssign(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>assignment</md-icon>Assign</md-button></md-menu-item>"
                                +"</md-menu-content>"
                        +"</md-menu>",
            }
        ];
//MWPostedDate
        applications.cols = [

            {
                field:"AccountApplicationNumber",
                title: "AccountApplicationNumber",
                type: "text",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('AccountApplicationNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"AccountApplicationNumber\")' ></i></span>"

            },
            {   
                field:"CustomerName",
                title: "CustomerName",
                type: "alpha",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('CustomerName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"CustomerName\")' ></i></span>"

            },
            {
                field:"NationalIdentifierValue",
                title: "NationalIdentifierValue",
                type: "numeric",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('NationalIdentifierValue')}\" >{{'Cnic' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"NationalIdentifierValue\")' ></i></span>",
                template: " {{dataItem.NationalIdentifierValue}} "


            },
            {
                field:"ProductName",
                title:"Product",
                type: "select",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"ProductName\")' ></i></span>"

            },
            // {
            //     field:"ApprovedLoanAmount",
            //     title:"Amount",
            //     type: "integer",
            //     search: true,
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('RequestedLoanAmount')}\" >Amount<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"RequestedLoanAmount\")' ></i></span>"
            // },
            // {
            //     field:"TotalTenure",
            //     title:"Tenure",
            //     type: "select",
            //     search: true,
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('TotalTenure')}\" >Tenure<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"TotalTenure\")' ></i></span>"
            // },
            {
                field:"BranchName",
                title:"LoanBranch ",
                type:"text",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('BranchName')}\" >{{'LoanBranch' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"BranchName\")' ></i></span>"
            },
            {
                field:"Creator",
                title:"Creator",
                type: "text",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('Creator')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"Creator\")' ></i></span>"
            },
            {
                field:"Fromaccountopeningrequestdate",
                title:"FromAppDate",
                type: "date",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active':AccountOpeningApplicationCtrl.isFiltered('accountopeningrequestdate')}\" >{{'FromAppDate' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"accountopeningrequestdate\")' ></i></span>"
            },
            {
                field:"Toaccountopeningrequestdate",
                title:"ToAppDate",
                type: "date",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active':AccountOpeningApplicationCtrl.isFiltered('accountopeningrequestdate')}\" >{{'ToAppDate' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"accountopeningrequestdate\")' ></i></span>"
            },
            {
                field:"Status",
                title:"Status",
                type: "text",
                //search: true,
                isNumber: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AccountOpeningApplicationCtrl.isFiltered('Status')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='AccountOpeningApplicationCtrl.isFiltered(\"Status\")' ></i></span>"
            }
        ];


        return applications;

    }]);
})();